// INTIVIV Official Logo Mark — extracted directly from brand PDF
export const IntivivLogoMark = ({ width = 52, className = "" }) => {
    const height = Math.round(width * 0.51);
    return (
        <svg
            width={width}
            height={height}
            viewBox="218 245 150 77"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="INTIVIV Logo Mark"
        >
            <g transform="matrix(1,0,0,-1,0,841.8898)">
                <path
                    d="M220.7052 587.0177C247.29 590.5366 262.4071 557.6437 276.95 535.7923 277.5767 534.8503 278.4407 533.0577 279.32 534.9217 297.9312 574.378 309.2182 592.9886 339.5815 591.9469 317.2654 586.5877 309.4449 560.4523 293.6843 537.1296 290.3066 532.1319 285.4848 523.9108 278.9232 523.6628 265.985 523.364 251.0011 552.7531 244.5395 564.078 238.9601 573.8559 233.4203 581.8031 220.7052 587.0177"
                    fill="#C9A84C"
                />
                <path
                    d="M289.3422 566.8217 281.4939 553.2667C279.6806 556.2624 278.1091 559.0066 276.8581 561.1995 271.2796 570.9764 258.9267 585.4003 241.8092 589.3347 262.9213 594.4643 277.7372 582.1951 289.3422 566.8217ZM305.4368 543.2241 298.2212 530.9218C302.5327 526.8056 306.9975 524.073 311.2418 524.1711 317.8035 524.4191 322.7953 532.3014 326.1722 537.2989 341.9325 560.6206 342.4725 585.4025 364.7886 590.7617 334.4253 591.8034 331.8945 575.0796 312.0987 535.7931 311.1715 533.9531 310.3549 535.7228 309.7287 536.6636 308.3448 538.7437 306.9153 540.9425 305.4368 543.2241"
                    fill="#C9A84C"
                />
            </g>
        </svg>
    );
};

export const IntivivLogoFull = ({ width = 140, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <IntivivLogoMark width={Math.round(width * 0.32)} />
        <span style={{ fontFamily: "'Playfair Display', serif", fontSize: width * 0.145, fontWeight: 600, letterSpacing: '0.15em', color: '#C9A84C' }}>
            INTIVIV<sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>™</sup>
        </span>
    </div>
);
